import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Brain, Laptop, TrendingUp, FlaskConical, Palette, Landmark, Heart } from 'lucide-react';
const CATEGORIES = [{
  name: 'Ficción',
  icon: BookOpen,
  color: 'text-blue-600',
  bg: 'bg-blue-50'
}, {
  name: 'No Ficción',
  icon: Landmark,
  color: 'text-slate-600',
  bg: 'bg-slate-50'
}, {
  name: 'Tecnología',
  icon: Laptop,
  color: 'text-indigo-600',
  bg: 'bg-indigo-50'
}, {
  name: 'Desarrollo Personal',
  icon: Brain,
  color: 'text-emerald-600',
  bg: 'bg-emerald-50'
}, {
  name: 'Negocios',
  icon: TrendingUp,
  color: 'text-amber-600',
  bg: 'bg-amber-50'
}, {
  name: 'Ciencia',
  icon: FlaskConical,
  color: 'text-cyan-600',
  bg: 'bg-cyan-50'
}, {
  name: 'Arte y Diseño',
  icon: Palette,
  color: 'text-purple-600',
  bg: 'bg-purple-50'
}, {
  name: 'Romance',
  icon: Heart,
  color: 'text-rose-600',
  bg: 'bg-rose-50'
}];
export function Categories() {
  return <section id="categorias" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-41">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-42">
        <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-43">
          Explorar por Categorías
        </h2>
        <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-44">
          Encuentra exactamente lo que buscas navegando por nuestras secciones
          especializadas.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-45">
        {CATEGORIES.map((category, index) => {
        const Icon = category.icon;
        return <motion.a href={`#${category.name.toLowerCase()}`} key={category.name} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="group flex flex-col items-center justify-center p-6 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-indigo-100 transition-all cursor-pointer" data-id="element-46">
              <div className={`p-4 rounded-full ${category.bg} ${category.color} mb-4 group-hover:scale-110 transition-transform`} data-id="element-47">
                <Icon className="w-6 h-6" data-id="element-48" />
              </div>
              <h3 className="font-medium text-slate-900 text-center" data-id="element-49">
                {category.name}
              </h3>
            </motion.a>;
      })}
      </div>
    </section>;
}